// extracted by mini-css-extract-plugin
export default {"FSlogo":"FormHeader_FSlogo__OLT4r","logo":"FormHeader_logo__syK+4","frameHeader":"FormHeader_frameHeader__jFIXO"};